"use client";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { COLOR_TOKENS } from "~/designSystem/constants/token";

import {
  BUTTON_SIZES_MAP,
  BUTTON_STYLED_PROPS,
  BUTTON_VARIANTS,
} from "../../constants";

import { BaseStyledButton } from "./BaseStyledButton";

type SecondaryStyledButtonProps = {
  $size: keyof typeof BUTTON_SIZES_MAP;
  $loading: boolean;
};
export const SecondaryStyledButton = styled(BaseStyledButton, {
  shouldForwardProp: prop =>
    !BUTTON_STYLED_PROPS.secondary.includes(
      prop as keyof SecondaryStyledButtonProps,
    ),
})<SecondaryStyledButtonProps>`
  background: ${({ $loading }) =>
    $loading
      ? BUTTON_VARIANTS.secondary.background.loading
      : BUTTON_VARIANTS.secondary.background.default};
  color: ${BUTTON_VARIANTS.secondary.text.default};
  border: 1px solid ${BUTTON_VARIANTS.secondary.border.default};
  &:hover {
    ${({ $loading }) =>
      !$loading &&
      css`
        background: ${BUTTON_VARIANTS.secondary.background.hover};
        transition: background 0.1s ease-in-out;
      `}
  }
  &:focus {
    ${({ $loading }) =>
      !$loading &&
      css`
        background: ${BUTTON_VARIANTS.secondary.background.focus};
        box-shadow: 0 0 0 3px ${COLOR_TOKENS.core.silver.a6};
        transition: all 0.1s ease-in-out;
        border: 1px solid ${BUTTON_VARIANTS.secondary.border.focus};
      `}
  }
  &:disabled {
    background: ${BUTTON_VARIANTS.secondary.background.disabled};
    color: ${BUTTON_VARIANTS.secondary.text.disabled};
    border: 1px solid ${BUTTON_VARIANTS.secondary.border.disabled};
  }
  .octolane-button-content {
    gap: ${({ $size }) => BUTTON_SIZES_MAP[$size].gap};
  }
`;
